<template>
  <v-slide-y-transition mode="out-in">

    <v-container v-show="display" fluid grid-list-xl text-xs-center>
      <h1 v-if="!this.status.value" class="page-title display-1">Crear nuevo tipo de instalación</h1>
      <h1 v-else class="page-title display-1">Detalles del tipo de instalación</h1>
      <v-layout row justify-space-between wrap>

        <v-flex xs12 sm12 md12 lg12 xl12>

          <vuetify-editable-form-card
            ref="characteristics"
            :color="'primary'"
            :toolbar-title="'Tipo de instalación'"
            :items="fields"
            @on-click-button="onClickButton"
            @on-change="onChange"
          ></vuetify-editable-form-card>

          <v-card class="vuetify-editable-form-card" tile light>
            <v-toolbar color="primary" dark>
              <v-toolbar-title>Inclusiones</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
              <v-card-text class="checkboxes">
                <v-layout column>
                  <v-checkbox
                    color="indigo"
                    v-for="(inclusion, i) in inclusions" :key="i"
                    v-model="inclusion.value"
                    :label="inclusion.installation_includes_name"
                    @change="onChangeCheckboxes('inclusion')"
                  ></v-checkbox>
                </v-layout>
              </v-card-text>
          </v-card>

          <v-card class="vuetify-editable-form-card" tile light>
            <v-toolbar color="primary" dark>
              <v-toolbar-title>Exclusiones</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
              <v-card-text class="checkboxes">
                <v-layout column>
                  <v-checkbox
                    color="indigo"
                    v-for="(exclusion, i) in exclusions" :key="i"
                    v-model="exclusion.value"
                    :label="exclusion.installation_excludes_name"
                    @change="onChangeCheckboxes('exclusion')"
                  ></v-checkbox>
                </v-layout>
              </v-card-text>
          </v-card>
        </v-flex>


            <v-tooltip right>
              <v-btn
                v-if="isNew()"
                dark
                fab
                fixed
                bottom
                slot="activator"
                left
                color="primary"
                @click="returnToTypes()"
              >
                <v-icon>arrow_back</v-icon>
              </v-btn>
              <span>Salir sin guardar</span>
            </v-tooltip>
            <v-tooltip left>
              <v-btn
                v-if="isNew()"
                dark
                fab
                fixed
                slot="activator"
                bottom
                right
                color="green"
                @click="validateEquipment()"
              >
                <v-icon>check</v-icon>
              </v-btn>
              <span>Guardar</span>
            </v-tooltip>
      </v-layout>
    </v-container>
  </v-slide-y-transition>

</template>

<script>
  import Rule from 'mixins/rule'
  import VisibleFor from '@/components/vue-user/visible-for'
  import VuetifyEditableFormCard from '@/components/vuetify-editable-form-card'
  import VuetifyTextField from '@/components/vuetify-form-creator/fields/vuetify-text-field'
  import VuetifyAvatarCard from '@/components/vuetify-avatar-card'

  export default {
    mixins: [Rule],

    components:
    {
      VisibleFor,
      VuetifyEditableFormCard,
      VuetifyAvatarCard,
      VuetifyTextField
    },

    data () {
      return {
        image: {},
        images: [],
        status: {},
        alias: {},
        installationType: [],
        characteristics: [],
        equipment: [],
        models: null,
        clickTimer: null,
        display: false,
        typeID: {},
        inclusionsField: {},
        exclusionsField: {},
        fields: [],
        inclusions: [],
        exclusions: []
      }
    },

    created () {
      this.getItem().then((response) => {
        this.normalizeAndAssign(response.data)
        this.getInclusions().then((response) => {
          let data = response.data ? (response.data.items || []) : []
          data.forEach((item) => {
            this.inclusions.push({
              installation_includes_id: item.installation_includes_id,
              installation_includes_name: item.installation_includes_name,
              value: false
            })
          })
          this.inclusionsField.value = this.inclusionsField.value ? JSON.parse(this.inclusionsField.value) : []
          this.markInclusions()
          this.getExclusions().then((response) => {
            data = response.data ? (response.data.items || []) : []
            data.forEach((item) => {
              this.exclusions.push({
                installation_excludes_id: item.installation_excludes_id,
                installation_excludes_name: item.installation_excludes_name,
                value: false
              })
            })
            this.exclusionsField.value = this.exclusionsField.value ? JSON.parse(this.exclusionsField.value) : []
            this.markExclusions()
            this.display = true
          }).catch((error) => {
            console.log(error)
          })
        }).catch((error) => {
          console.log(error)
        })
      }).catch((error) => {
        console.log(error)
      })
    },

    methods:
    {
      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      normalizeAndAssign (params) {
        let filter = (param, def) => {
          return (typeof param !== 'undefined') ? param : def
        }
        params.map((obj, index) => {
          obj.label = filter(obj.label, undefined)
          obj.ref = filter(obj.ref, '')
          obj.order = filter(obj.order, '')
          obj.assign_to = filter(obj.assign_to, 'fields')
          obj.value_class = filter(obj.value_class, '')
          obj.tooltip = filter(obj.tooltip, 'Pulsa para editar')
          obj.focus_next_on_enter = filter(obj.focus_next_on_enter, true)
          obj.dark = filter(obj.dark, false)
          obj.color = filter(obj.color, 'primary')
          obj.columns = filter(obj.columns, 'xs12 sm6 md6 lg6')
          obj.counter = filter(obj.counter, false)
          obj.dialog = filter(obj.dialog, false)
          obj.editable = filter(obj.editable, false)
          obj.required = filter(obj.required, false)
          obj.disabled = filter(obj.disabled, false)
          obj.add_on_enter = filter(obj.add_on_enter, true)
          obj.type = filter(obj.type, 'select')
          obj.autocomplete = filter(obj.autocomplete, false)
          obj.rules = this.setRules(obj.rules)
          if (Array.isArray(this[obj.assign_to])) {
            this[obj.assign_to].push(obj)
          } else {
            this[obj.assign_to] = obj
          }
          return obj
        })
        return params
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getMarkedInclusions () {
        let items = []
        this.inclusions.forEach((item) => {
          if (item.value === true) {
            items.push(parseInt(item.installation_includes_id))
          }
        })
        return items
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getMarkedExclusions () {
        let items = []
        this.exclusions.forEach((item) => {
          if (item.value === true) {
            items.push(parseInt(item.installation_excludes_id))
          }
        })
        return items
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      markInclusions () {
        this.inclusions.forEach((item) => {
          let index = this.inclusionsField.value.indexOf(parseInt(item.installation_includes_id))
          if (index > -1) {
            item.value = true
          }
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      markExclusions () {
        this.exclusions.forEach((item) => {
          let index = this.exclusionsField.value.indexOf(parseInt(item.installation_excludes_id))
          if (index > -1) {
            item.value = true
          }
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChangeAvatar (item) {
        this.onChange(item.src, null, item, true)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onUploadError (type, requiredValue) {
        let errors = {
          'format': 'ERROR: La imagen debe tener un formato: ' + requiredValue,
          'max-file-size': 'ERROR: La imagen no debe superar los ' + (requiredValue / 1000) + 'kB',
          'width': 'ERROR: La imagen debe tener un ancho de ' + requiredValue + 'px',
          'height': 'ERROR: La imagen debe tener un alto de ' + requiredValue + 'px'
        }
        this.$awn.alert(errors[type])
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChangeStatus () {
        let status = parseInt(this.status.value) === 1 ? 2 : 1
        this.status.value = status
        this.onChange(this.status.value, null, this.status, true)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      addRates () {
        let fields = [
          {
            assign_to: 'installationType',
            type: 'text-field',
            columns: 'xs4',
            label: 'Precio instalación (1)',
            disabled: true,
            editable: true,
            static_field: true,
            append_text: '€',
            value: ''
          },
          {
            assign_to: 'installationType',
            type: 'text-field',
            columns: 'xs4',
            label: 'Precio instalación (2)',
            disabled: true,
            editable: true,
            static_field: true,
            append_text: '€',
            value: ''
          },
          {
            assign_to: 'installationType',
            type: 'text-field',
            columns: 'xs4',
            label: 'Precio instalación (3)',
            disabled: true,
            editable: true,
            static_field: true,
            append_text: '€',
            value: ''
          },
          {
            assign_to: 'installationType',
            type: 'text-field',
            columns: 'xs12',
            label: 'Duración',
            disabled: true,
            editable: true,
            static_field: true,
            append_text: 'h',
            value: ''
          }
        ]
        this.normalizeAndAssign(fields)
        this.setRatesValues()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setRatesValues () {
        if (this.installationType[0].value) {
          this.installationType[1].value = this.installationType[0].value[this.installationType[0].item_text_2]
          this.installationType[2].value = this.installationType[0].value[this.installationType[0].item_text_3]
          this.installationType[3].value = this.installationType[0].value[this.installationType[0].item_text_4]
          this.installationType[4].value = this.installationType[0].value[this.installationType[0].item_text_5]
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getExclusions () {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'installation/exclusions/'
          }).then((response) => {
            // console.log(response.data)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al obtener el perfil: ' + this.$store.getters['api/getMessage']
            )
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getInclusions () {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'installation/inclusions/'
          }).then((response) => {
            // console.log(response.data)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al obtener el perfil: ' + this.$store.getters['api/getMessage']
            )
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChangeCheckboxes (type) {
        if (type === 'inclusion') {
          this.updateSelectedInclusions()
        } else {
          this.updateSelectedExclusions()
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      updateSelectedInclusions () {
        let selected = this.getMarkedInclusions()
        this.inclusionsField.value = selected
        this.updateItem(this.inclusionsField, JSON.stringify(selected))
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      updateSelectedExclusions () {
        let selected = this.getMarkedExclusions()
        this.exclusionsField.value = selected
        this.updateItem(this.exclusionsField, JSON.stringify(selected))
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isNew () {
        return this.$route.params.installation_type_id === 'new'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onClickButton (item, isValid) {
        if (item.ref === 'submit-button' && isValid) {
          this.status.value = '1'
          this.$router.push(
            {
              name: 'equipment-id',
              params: {
                equipment_id: this.typeID.value
              }
            }
          )
          this.$forceUpdate()
        } else if (item.ref === 'cancel-button') {
          this.display = false
          this.$router.push(
            {
              name: 'equipments'
            }
          )
          this.deleteItem(this.typeID.value)
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      deleteItem (typeID) {
        this.$store.dispatch('api/authRequest', {
          method: 'delete',
          url: 'installation/type/' + typeID + '/'
        }).then((response) => {
          // console.log(response.data)
        }).catch((error) => {
          console.log(error)
          this.$awn.alert('Error al guardar: ' + this.$store.getters['api/getMessage'])
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getItem () {
        return new Promise((resolve, reject) => {
          let id = this.$route.params.installation_type_id
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'installation/type/' + id + '/'
          }).then((response) => {
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$awn.alert('Error al obtener el tipo de instalación: ' + this.$store.getters['api/getMessage'])
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChange (newVal, oldVal, item, isValid) {
        // console.log('········> ', newVal, oldVal)
        if (this.$store.getters['api/getStatus'] !== 'loading') {
          if (this.display && isValid && newVal !== oldVal) {
            item.value = newVal
            if (newVal && item.type === 'select') {
              this.updateItem(item, newVal[item.item_value])
            } else if ((item.type === 'text-field' || item.type === 'hidden' || item.type === 'image') && !item.static_field) {
              item.value = newVal
              this.updateItem(item, item.value)
            }
          }
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      validateEquipment () {
        let characteristics = this.$refs.characteristics.$refs.form_creator.validateForm()
        if (characteristics) {
          this.$router.push(
            {
              name: 'installation-type-id',
              params: {
                installation_type_id: this.typeID.value
              }
            }
          )
        } else {
          this.$awn.warning('Debes completar todos los campos requeridos')
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      returnToTypes () {
        this.$router.push(
          {
            name: 'types'
          }
        )
        this.deleteItem(this.typeID.value)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      normalizeModels (item) {
        if (!item.value) {
          return false
        }
        let currentBrandID = item.value[item.item_value]

        if (item.brands_relations[currentBrandID]) {
          if (!this.models) {
            this.models = this.equipment[2].items
          }
          let brandModels = item.brands_relations[currentBrandID]

          let items = []
          this.models.forEach(obj => {
            let modelID = obj[this.equipment[2].item_value]

            if (brandModels.indexOf(modelID) > -1) {
              items.push(obj)
            }
          })

          let index = -1
          if (this.equipment[2].value && this.equipment[2].value[this.equipment[2].item_value]) {
            let id = this.equipment[2].value[this.equipment[2].item_value]
            index = items.findIndex(element => parseInt(element[this.equipment[2].item_value]) === parseInt(id))
          }

          this.equipment[2].items = items

          this.equipment[2].value = index > -1 ? items[index] : (items[0] || [])
        } else {
          this.equipment[2].items = []
          this.equipment[2].value = ''
        }
        // console.log('||||||||||||||', this.equipment[2].value)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onAddItem (newVal, oldVal, item, isValid) {
        let typeID = this.typeID.value
        this.$store.dispatch('api/authRequest', {
          method: 'post',
          url: 'equipment/' + typeID + '/',
          data: {
            controller: item.item_controller,
            value: newVal
          }
        }).then((response) => {
          let value = {
            [item.item_text]: newVal,
            [item.item_value]: response.data
          }
          item.items.unshift(value)
          item.value = item.items[0]
        }).catch((error) => {
          console.log(error)
          this.$awn.alert('Al agregar nuevo elemento')
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      updateItem (item, value) {
        let typeID = this.typeID.value
        this.$store.dispatch('api/authRequest', {
          method: 'put',
          url: 'installation/type/' + typeID + '/',
          data: {
            table: item.table,
            column: item.column,
            data_type: item.data_type,
            value: value
          }
        }).then((response) => {
          console.log(response)
          this.$awn.success('¡Hecho!')
        }).catch((error) => {
          console.log(error)
          this.$awn.alert('Al actualizar')
        })
      }
    },

    watch: {
      'corporation.2.value': {
        handler: function (newVal, oldVal) {
          // console.log(newVal)
        },
        deep: true
      }
    }
  }
</script>

<style lang="sass">

.application
  background: rgba(63, 81, 181, 0.07058823529411765) !important

a
 text-decoration: none

.image 
  cursor: pointer

.flex
  /* padding: 5px 12px */

.container.grid-list-xl *:not(:only-child) .layout:first-child
  margin-top: 0px

.jst-card
  margin-bottom: 20px

.add-area

.carousel-actions
  padding: 18px

.carousel
  height: 250px
  width: 250px
  margin: 0 auto
  box-shadow: none

.input-file
  display: none

.image-info
  width: 72%

.add-address
  display: hidden

.address-autocomplete
  max-width: 435px
  margin: 0 auto
  padding: 32px 0 32px 0

.list-item
  display: inline-block
  margin-right: 10px

.list-enter-active, .list-leave-active
  transition: all 1s

.list-enter, .list-leave-to
  opacity: 0
  transform: translateY(30px)

html
  overflow-y: visible !important

.profile-options
  float: right
  bottom: 62px

.disable-area
  opacity: 0.5;
  pointer-events: none;
  cursor: default;
  text-decoration: none;
  -webkit-transition: opacity 1s ease-in-out;
  -moz-transition: opacity 1s ease-in-out;
  -ms-transition: opacity 1s ease-in-out;
  -o-transition: opacity 1s ease-in-out;
  transition: opacity 1s ease-in-out;

.carousel-actions
  padding: 18px

.checkboxes
  padding: 36px

.avatar-info
  width: 72%

</style>



// WEBPACK FOOTER //
// src/pages/installation-type.vue